/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class HTHIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: true,
        xNudge: true,
        xSplit: true,
        xBet: true,
        volatility: Volatility.HIGH
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/Intro_Feature_1.png");
        imgLoader.add("feature2", "resources/images/Intro_Feature_2.png");
        imgLoader.add("feature3", "resources/images/Intro_Feature_3.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add("logoSmall", "resources/images/intro_logo_small.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    public onResize() {
        const logoSprite: PIXI.Sprite = <PIXI.Sprite>this.borderTop.children[1];
        logoSprite.texture = ImgLoader.getImgTexture(NolimitApplication.isLandscape ? "logoSmall" : "logo");
        logoSprite.position = NolimitApplication.isLandscape ? new PIXI.Point(-512, -38) : new PIXI.Point(55, -233);
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        topSprite.position.set(0, -40);

        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(NolimitApplication.isLandscape ? "logoSmall" : "logo"));
        logoSprite.anchor.set(0.5, 0.5);
        NolimitApplication.isLandscape ? logoSprite.scale.set(0.9, 0.9) : logoSprite.scale.set(1, 1);
        logoSprite.position = NolimitApplication.isLandscape ? new PIXI.Point(-512, -38) : new PIXI.Point(55, -233);

        this.borderTop.addChild(topSprite, logoSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        bottomSprite.position.set(0, 40);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();

        this.pages = [
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage()];


        const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
        featureSprite1.anchor.set(0.5, 0.5);
        this.pages[0].addChild(featureSprite1);
        const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
        featureSprite2.anchor.set(0.5, 0.5);
        this.pages[1].addChild(featureSprite2);
        const featureSprite3 = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
        featureSprite3.anchor.set(0.5, 0.5);
        this.pages[2].addChild(featureSprite3);
    }
}